// Génération des paramètres PKCE / state / nonce via Web Crypto API.
// RFC 7636 : code_verifier aléatoire + code_challenge = SHA-256 base64url.

function randomBase64Url(byteLength: number): string {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** code_verifier : 64 octets aléatoires (86 caractères base64url, dans la plage RFC 43-128) */
export function generateCodeVerifier(): string {
  return randomBase64Url(64);
}

/** code_challenge = BASE64URL(SHA-256(code_verifier)) — méthode S256 */
export async function generateCodeChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64UrlEncode(new Uint8Array(digest));
}

/** state : protection CSRF sur le round-trip d'autorisation */
export function generateState(): string {
  return randomBase64Url(32);
}

/** nonce : protection contre le rejeu du id_token */
export function generateNonce(): string {
  return randomBase64Url(32);
}
